import { Col, DatePicker, Input, Row, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";

import { enumFieldType } from "../../constant/WebToLead";

const CustomFields = ({ wtlCustomFields, onChange }) => {
  return (
    <>
      {!!wtlCustomFields?.length && (
        <div
          className="heading18px w-100 fw-semibold"
          style={{ margin: "30px 0 20px 0", padding: "5px 0" }}
        >
          Custom Fields
        </div>
      )}
      {wtlCustomFields?.map((data, i) => (
        <Row key={i} className="justify-content-between mb15">
          <Col span={6}>
            <label>{data?.fieldName}</label>
          </Col>
          <Col span={17}>
            <RenderComponent
              fieldType={data?.fieldType}
              fieldValue={data?.fieldValue}
              onChange={(value) => onChange(data?.fieldName, value)}
              pickValues={data?.pickValues?.map((option) => ({
                label: option,
                value: option,
              }))}
            />
          </Col>
        </Row>
      ))}
    </>
  );
};

const RenderComponent = ({
  fieldType,
  fieldValue,
  fieldName,
  onChange,
  pickValues,
}) => {
  const renderSwitch = (type) => {
    switch (type) {
      case enumFieldType.TEXT:
        return (
          <Input
            name={fieldName}
            value={fieldValue}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.CURRENCY:
        return (
          <Input
            name={fieldName}
            value={fieldValue}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.TEXT_AREA:
        return (
          <TextArea
            name={fieldName}
            value={fieldValue}
            rows={2}
            maxLength={500}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.INTEGER:
        return (
          <Input
            name={fieldName}
            type="number"
            value={fieldValue}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.EMAIL:
        return (
          <Input
            name="email"
            value={fieldValue}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.PHONE:
        return (
          <Input
            name="phone"
            type="number"
            min={0}
            max={20}
            value={fieldValue}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.URL:
        return (
          <Input
            name="url"
            value={fieldValue}
            placeholder={fieldName}
            onChange={(v) => onChange(v.target.value)}
          />
        );
      case enumFieldType.PICK_LIST:
        return (
          <Select
            defaultValue={fieldValue}
            style={{ width: "100%" }}
            options={pickValues}
            onChange={(value) => onChange(value)}
          />
        );
      case enumFieldType.MULTI_PICK_LIST:
        return (
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Please select"
            defaultValue={
              fieldValue?.split(", ")?.filter((d) => d !== "")?.length
                ? fieldValue?.split(", ")?.filter((d) => d !== "")
                : !!fieldValue.length
                  ? [fieldValue]
                  : []
            }
            onChange={(value) => onChange(value?.join(", "))}
            options={pickValues}
          />
        );
      case enumFieldType.DATE:
        return (
          <DatePicker
            defaultValue={dayjs(fieldValue)}
            onChange={(date) => onChange(dayjs(date).format())}
          />
        );
      default:
        return <></>;
    }
  };

  return <div>{renderSwitch(fieldType)}</div>;
};

export default CustomFields;
